import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=dfdd89dc&scoped=true"
import script from "./edit.vue?vue&type=script&lang=ts&setup=true"
export * from "./edit.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./edit.vue?vue&type=style&index=0&id=dfdd89dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdd89dc",
  null
  
)

export default component.exports